(() => {
  if (window.tifHomeReady) return;
  window.tifHomeReady = true;
  let visitSeed;
  try {
    visitSeed = sessionStorage.getItem('tif-home-visit');
    if (!visitSeed) {
      visitSeed = String(Math.random());
      sessionStorage.setItem('tif-home-visit', visitSeed);
    }
  } catch (_) { visitSeed = 'storage-unavailable'; }
  const score = id => {
    let hash = 2166136261;
    for (const c of visitSeed + ':' + id) hash = Math.imul(hash ^ c.charCodeAt(0), 16777619);
    return hash >>> 0;
  };
  const requests = new Map();
  async function catalogue(source) {
    if (requests.has(source)) return requests.get(source);
    const request = (async () => {
      let url = new URL(source, location.origin);
      url.searchParams.set('sort_by', 'created-descending');
      const products = new Map(), pages = new Set();
      while (url) {
        url.searchParams.set('section_id', 'tif-home-catalog');
        if (pages.has(url.href)) throw new Error('Repeated catalogue page');
        pages.add(url.href);
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Catalogue unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const root = doc.querySelector('[data-home-catalog]');
        if (!root) throw new Error('Catalogue section unavailable');
        root.querySelectorAll('template[data-home-product]').forEach(t => products.set(t.dataset.homeProduct, t));
        url = root.dataset.next ? new URL(root.dataset.next, location.origin) : null;
        if (url && url.origin !== location.origin) throw new Error('Invalid catalogue page');
      }
      return [...products.values()].sort((a,b) => Number(b.dataset.created)-Number(a.dataset.created) || b.dataset.homeProduct.localeCompare(a.dataset.homeProduct));
    })();
    requests.set(source,request);
    try { return await request; } catch (error) { requests.delete(source); throw error; }
  }
  async function prepare(root = document) {
    for (const feed of root.querySelectorAll('[data-home-feed]')) {
      if (feed.dataset.homeReady) continue;
      feed.dataset.homeReady='loading';
      try {
        const products=await catalogue(feed.dataset.source);
        if (!feed.isConnected) continue;
        const limit=Number(feed.dataset.limit)||27;
        const count=Math.min(Number(feed.dataset.newest)||0,limit,products.length);
        const remaining=products.slice(count);
        if (feed.dataset.shuffle==='true') remaining.sort((a,b)=>score(a.dataset.homeProduct)-score(b.dataset.homeProduct));
        const selected=[...products.slice(0,count),...remaining].slice(0,limit);
        const blocks=[...feed.children].filter(el=>el.hasAttribute('data-after-product'));
        const fragment=document.createDocumentFragment();
        for(let i=0;i<=selected.length;i++) {
          blocks.filter(b=>Math.min(Number(b.dataset.afterProduct),selected.length)===i).forEach(b=>fragment.append(b));
          if(i<selected.length) {
            const card=selected[i].content.firstElementChild.cloneNode(true);
            card.dataset.homeProduct=selected[i].dataset.homeProduct;
            card.dataset.created=selected[i].dataset.created;
            if(i<5) card.querySelector('img')?.setAttribute('loading','eager');
            fragment.append(card);
          }
        }
        feed.replaceChildren(fragment);
        feed.dataset.homeReady='true';
        window.tifPrepareColours?.(feed);
        document.dispatchEvent(new CustomEvent('tif:home-updated',{detail:{feed}}));
      } catch (_) { feed.dataset.homeReady='fallback'; }
    }
  }
  prepare();
  document.addEventListener('shopify:section:load',event=>{requests.clear();prepare(event.target);});
})();
